import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RuleForm from '../inputs/RuleForm';
import InlineRegionSelect from '../inputs/InlineRegionSelect';
import InlineSupplierSelect from '../inputs/InlineSupplierSelect';
import InlineInputNumber from '../inputs/InlineInputNumber';


class NumberOfOrdersRule extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onReset = this.onReset.bind(this);
    const { initialValues } = props;
    this.initialState = {
      count: initialValues.count || 5,
      supplier: initialValues.supplier || 'all',
      regions: initialValues.regions && initialValues.regions.length > 0 ? initialValues.regions : [0]
    };
    this.state = this.initialState;
  }

  onSubmit(event) {
    event.preventDefault();
    const value = _.omit(this.state, 'regions');
    this.props.onSubmit({
      kind: 'number_of_orders',
      regions: _.filter(this.state.regions),
      value
    });
  }

  onReset() {
    this.setState(this.initialState);
  }

  render() {
    const { count, supplier, regions } = this.state;
    const { form, type, ...other } = this.props;

    return (
      <RuleForm
        {...other}
        onSubmit={this.onSubmit}
        onReset={this.onReset}
        isSubmitting={form.is_submitting}
      >
        <InlineRegionSelect
          onChange={val => this.setState({ regions: val })}
          value={regions}
        />
        <InlineSupplierSelect
          value={supplier}
          onChange={supplier_id => this.setState({ supplier: supplier_id })}
          include_any={false}
        />
        <InlineInputNumber
          label='Order Count'
          description='The amount of orders made in a month'
          value={count}
          onChange={value => this.setState({ count: value })}
        />
      </RuleForm>
    );
  }
}

NumberOfOrdersRule.defaultProps = {
  type: 'add',
  initialValues: {}
};

NumberOfOrdersRule.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  type: PropTypes.string,
  initialValues: PropTypes.object,
};

export default NumberOfOrdersRule;
